import { gql } from '@apollo/client';

export const ASSIGN_MEMBER = gql`
mutation AssignMember($input: AssignMemberInput) {
  assignMember(input: $input)
}
`;

export const GET_SKILL_MEMBER = gql`
query GetProjectSkill($projectId: Int!, $skillId: Int!) {
  getProjectSkill(projectId: $projectId, skillId: $skillId) {
    members
    skillName
  }
}
`;

export const DELETE_MEMBER = gql`
mutation DeleteProjectSkillUser($input: DeleteProjectSkillUserInput) {
  deleteProjectSkillUser(input: $input) {
    type
    message
  }
}
`;

export const MEMBER_LIST = gql`
query MemberList($projectId: Int!) {
  getProjectSkillUsers(projectId: $projectId) {
    id
    skillId
    projectId
    skill {
      name
    }
    user {
      id
      firstName
      lastName
      email
      googleId
    }
    workspaceProfile {
      createdAt
      displayName
      id
      isDisabled
      logo
      roleId
      userWorkspace {
        email
      }
      workspaceId
      userId
    }
  }
}
`;

export const REMOVE_ASSIGN = gql`
mutation RemoveMember($input: RemoveMemberInput) {
  removeMember(input: $input)
}
`;

export const ADD_MEMBERS = gql`
mutation AddProjectSkillUser($input: AddProjectSkillUserInput) {
  addProjectSkillUser(input: $input) {
    id
    projectId
    skillId
    skill {
      name
      id
    }
  }
}
`;
